import { get } from "lodash";
import { ENV_VARS } from "./envs";
var getEnv = function getEnv(_env) {
  if (ENV_VARS["NEXT_PUBLIC_IS_ONPREMISE"] === "true" && typeof window !== "undefined") {
    return get(window, ["__RUNTIME_CONFIG__", _env], ENV_VARS[_env]);
  }
  return ENV_VARS[_env];
};
export default getEnv;